export enum ApprovalStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    Canceled = 4,
    Referred = 5,
    FurtherDetails = 6,
    ApprovalRequest = 7,
}